export function loadFromStorage(key: string): string | null {
    try {
        return window.localStorage?.getItem(key) ?? null;
    } catch {
        return null;
    }
}

export function saveInStorage(key: string, value: string) {
    window.localStorage?.setItem(key, value);
}